import { Component } from '@angular/core';
import { CbIconModule } from '@chubb/ui-components';

@Component({
  selector: 'app-chubb-header',
  standalone: true,
  imports: [ CbIconModule ],
  templateUrl: './chubb-header.component.html',
  styleUrl: './chubb-header.component.scss'
})
export class ChubbHeaderComponent {


}

